import { MapPin } from "lucide-react";

interface GprofileLocationRadiusProps {
  precisionMeters?: number | null;
  showToOthers?: boolean | null;
  isOwnProfile?: boolean;
}

const GprofileLocationRadius = ({ 
  precisionMeters, 
  showToOthers, 
  isOwnProfile = false 
}: GprofileLocationRadiusProps) => {
  // Don't show to others if they haven't enabled it (unless it's their own profile)
  if (!precisionMeters || (!isOwnProfile && !showToOthers)) {
    return null;
  }

  const getRadiusText = (meters: number) => {
    if (meters >= 1000) {
      return `${meters / 1000}km`;
    }
    return `${meters}m`;
  };

  return (
    <div className="px-4 py-3 text-center border-t border-ice-white/10">
      <div className="flex items-center justify-center gap-2 text-ice-white/60 text-sm">
        <MapPin className="w-4 h-4" />
        <span>Location shown within {getRadiusText(precisionMeters)} radius</span>
      </div>
    </div>
  );
};

export default GprofileLocationRadius;